import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import "core-js/modules/es6.regexp.split";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { asTree } from 'prismic-richtext';
import { NODE_ELEMENTS } from './RichTextConst';

const getNodeName = (_ref) => {
  let {
    type
  } = _ref;
  return NODE_ELEMENTS[type] || null;
};

const getAttributes = arg => ({
  attrs: {
    href: arg.url
  }
});

const getClasses = (arg, cls) => ({
  class: [arg.label, cls]
});

const getProps = (_ref2, _ref3) => {
  let {
    element: {
      data = {}
    }
  } = _ref2;
  let {
    cls
  } = _ref3;
  return _objectSpread({}, getAttributes(data), getClasses(data, cls));
};

export default {
  functional: true,
  props: {
    payload: {
      type: Array,
      required: true
    },
    cls: {
      type: String,
      default: ''
    }
  },

  render(h, _ref4) {
    let {
      props
    } = _ref4;

    const reducer = (acc, text, idx) => {
      if (idx > 0) {
        acc.push(h('br'));
      }

      acc.push(text);
      return acc;
    };

    const injectBR = text => text.split('\n').reduce(reducer, []);

    const elementBuilder = node => {
      const NodeName = getNodeName(node);

      if (NodeName == null) {
        return injectBR(node.text);
      }

      return h(NodeName, _mergeJSXProps([{}, getProps(node, props)]), [node.children.length > 0 ? node.children.map(elementBuilder) : injectBR(node.text)]);
    };

    return asTree(props.payload).children.map(elementBuilder);
  }

};